import { toast } from "sonner";
import { Copy, LogOut } from "lucide-react";
import { dinero, fechaCorta } from "@/reclutamiento/logica";
import { BannerPago, CajaError, Esqueleto } from "../componentes";
import { usePortal } from "../contexto";
import { Mk } from "../iconos";
import { claveCache, copiar, useCarga } from "../util";

export function Cuenta() {
  const { api, sesion, soloLectura, salir } = usePortal();
  const carga = useCarga(() => api.cuenta(), [api], undefined, claveCache(sesion, api.verComo, "cuenta"));
  const c = carga.datos;
  const pendiente = c?.pagos.find((p) => p.estado === "pendiente") ?? null;
  const usuario = c?.usuario ?? sesion.usuario;

  return (
    <>
      <div className="phello">
        <h1>Mi cuenta</h1>
        <p>{sesion.cliente.nombre}</p>
      </div>
      <BannerPago conBoton={false} monto={pendiente ? `${dinero(pendiente.monto)} MXN` : null} />
      {carga.cargando && !c ? (
        <Esqueleto filas={2} alto={180} />
      ) : carga.error ? (
        <CajaError texto={carga.error} onReintentar={carga.recargar} />
      ) : c ? (
        <>
          {c.transferencia && (
            <article className="vcard" aria-labelledby="h-pagar">
              <h2 id="h-pagar">Cómo pagar</h2>
              <dl className="kv">
                {pendiente && (
                  <>
                    <dt>Monto</dt>
                    <dd className="num">{dinero(pendiente.monto)} MXN</dd>
                    <dt>Periodo</dt>
                    <dd>{pendiente.periodo}</dd>
                    <dt>Vence</dt>
                    <dd className="num">{fechaCorta(pendiente.vence)}</dd>
                  </>
                )}
                <dt>Banco</dt>
                <dd>{c.transferencia.banco}</dd>
                <dt>CLABE</dt>
                <dd className="num">{c.transferencia.clabe}</dd>
                <dt>Beneficiario</dt>
                <dd>{c.transferencia.beneficiario}</dd>
                {pendiente?.referencia && (
                  <>
                    <dt>Referencia</dt>
                    <dd className="num">{pendiente.referencia}</dd>
                  </>
                )}
              </dl>
              <button
                className="btn"
                style={{ alignSelf: "flex-start" }}
                onClick={async () =>
                  (await copiar(c.transferencia!.clabe.replace(/\s/g, "")))
                    ? toast.success("CLABE copiada")
                    : toast.error("No se pudo copiar")
                }
              >
                <Copy size={16} aria-hidden="true" /> Copiar CLABE
              </button>
              <p className="muted" style={{ fontSize: 13.5 }}>
                Al recibir tu transferencia la confirmamos y tus fichas se abren solas.
              </p>
            </article>
          )}

          <article className="vcard" aria-labelledby="h-periodos">
            <h2 id="h-periodos">Periodos</h2>
            {c.pagos.length ? (
              <div className="tablewrap">
                <table className="tcompacta">
                  <thead>
                    <tr>
                      <th>Periodo</th>
                      <th>Monto</th>
                      <th>Vence</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {c.pagos.map((p) => (
                      <tr key={p.id}>
                        <td>{p.periodo}</td>
                        <td className="num" style={{ whiteSpace: "nowrap" }}>
                          {dinero(p.monto)}
                        </td>
                        <td className="num" style={{ whiteSpace: "nowrap" }}>
                          {fechaCorta(p.vence)}
                        </td>
                        <td>
                          {p.estado === "pagado" ? (
                            <span className="pill ok">
                              <Mk k="ok" s={14} />
                              Pagado
                            </span>
                          ) : (
                            <span className="pill yel">
                              <Mk k="yel" s={14} />
                              Pendiente
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="muted">Todavía no hay periodos.</p>
            )}
          </article>
        </>
      ) : null}

      <article className="vcard" aria-labelledby="h-usuario">
        <h2 id="h-usuario">Usuario</h2>
        {usuario ? (
          <dl className="kv">
            <dt>Nombre</dt>
            <dd>{usuario.nombre}</dd>
            <dt>Correo</dt>
            <dd>{usuario.correo}</dd>
          </dl>
        ) : (
          <p className="muted">Este cliente todavía no tiene usuario del portal.</p>
        )}
        {!soloLectura && (
          <button className="btn" style={{ alignSelf: "flex-start" }} onClick={salir}>
            <LogOut size={16} aria-hidden="true" /> Salir
          </button>
        )}
      </article>
    </>
  );
}
